module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@2x-694fd232eda0aeb90ac71704f9e17aa9.png";